import React, {
  useCallback,
  useContext,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import RadioGroupContext from '../context'

import Styles from './styles.module.sass'


export default function RadioButton({ label, value, className, disabled, ...props }) {
  const {
    groupDisabled,
    handleChange,
    name,
    selectedValue,
  } = useContext(RadioGroupContext)

  const checked = ( selectedValue === value )
  const isDisabled = ( groupDisabled || disabled )

  const onChange = useCallback((e) => {
    e.stopPropagation()

    handleChange({
      checked: true,
      value,
    })
  }, [handleChange, value])

  const onKeyUp = useCallback((e) => {
    if ( e.key !== ' ' ) {
      return
    }

    onChange(e)
  }, [onChange])

  const rootClassName = classnames(Styles.root, className, {
    [Styles.disabled]: isDisabled,
  })

  const radioClassName = classnames(Styles.radio, {
    [Styles.checked]: checked,
    [Styles.disabled]: isDisabled,
  })

  const tabIndex = ( disabled ) ? -1 : 0

  return (
    <label
      tabIndex={ tabIndex }
      { ...props }
      aria-checked={ checked }
      aria-disabled={ isDisabled }
      className={ rootClassName }
      onKeyUp={ onKeyUp }
      role="radio"
    >
      <input
        checked={ checked }
        disabled={ isDisabled }
        className={ Styles.input }
        name={ name }
        onChange={ onChange }
        type="radio"
        value={ value }
      />
      <div className={ radioClassName }>
        <span className={ Styles.radio__inner } />
      </div>
      { label }
    </label>
  )
}

RadioButton.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,

  className: PropTypes.string,
  disabled: PropTypes.bool,
}
